module.exports = __webpack_public_path__ + "img/ettijeri.c28c67e5.png";